/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：244
 */

"use strict"

export { r as i }
export { o as h }
export { i as g }
export { a as f }
export { FFFFFFFF as a }
export { c }
export { l as b }
export { u as e }
export { d }
var r = 40
var o = 40
var i = 1800
var a = 3200
var /* [auto-meaningful-name] */FFFFFFFF = "#FFFFFFFF"
var c = 300
var l = 300
var u = false
var d = false
export default FFFFFFFF
